import React, { useState } from 'react';

interface AcknowledgeComponentProps {
  onAcknowledge: (acknowledged: boolean) => void; // Expecting a function that takes a boolean parameter
  acknowledge: boolean;
}

const AcknowledgeComponent: React.FC<AcknowledgeComponentProps> = ({ onAcknowledge, acknowledge }) => {

  const handleCheckboxChange = () => {
    onAcknowledge(!acknowledge); // Pass the acknowledgment status to parent
  };

  return (
    <div className="p-6 bg-gray-800 bg-white/10 border border-white/20 rounded-lg text-white">
      <div className="flex items-center gap-3 mb-4">
        <input
          type="checkbox"
          id="acknowledge"
          checked={acknowledge}
          onChange={handleCheckboxChange}
          className="w-5 h-5 text-yellow-500 border-yellow-500 focus:ring-2 focus:ring-yellow-300"
        />
        <label htmlFor="acknowledge" className="text-sm text-gray-100">
          I agree to receive SMS communications from <strong>Delight Long Island LLC</strong> on the cell-number I have provided only for the purpose of schedule change or tardiness request forms.
        </label>
      </div>

    </div>
  );
};

export default AcknowledgeComponent;

